export default class ArratDataUtils {

    // 實現一個等待函數 //true 等於
    static checkIsEquire(arr1,arr2) {
        return JSON.stringify(arr1) === JSON.stringify(arr2); // true
    }

    static containsObject(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i] === obj) {
                return true;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/helper/ArratDataUtils.js